import NotificationGuard from '@/features/notifications/notification-service-extension-shared/guards/app'
import i18n from '@/features/notifications/notification-service-extension-shared/translations'
import { NewOrderNotification } from '@/features/notifications/notification-service-extension-shared/types/app'
import { transformNotification } from '@/features/notifications/notification-service-extension-shared/utils/transforms'

interface NotificationContent {
    title: string
    subtitle: string
    body?: string
}

const formatNewOrderTitle = (notification: NewOrderNotification): string => {
    const deliveryType = i18n.t(
        `order.deliveryTypeCategory.${notification.orderDeliveryTypeCategory}`,
        notification.orderDeliveryTypeCategory
    )
    const channel = i18n.t(`order.channel.${notification.orderChannel}`, notification.orderChannel)

    return `${deliveryType} | ${channel} (${notification.orderShortCode})`
}

/**
 * This function is intended for use within an iOS Notification Service Extension
 * utilizing JavaScriptCore. As such, it is essential to minimize imports,
 * including only necessary resources such as specific i18n initialization
 * and translation files. Avoid importing the main application's i18next instance
 * to prevent loading unnecessary translations.
 */
export const formatPushNotificationContent = (data: any, lng: string): NotificationContent => {
    i18n.init({ lng })

    const notification = transformNotification(data)

    if (notification) {
        if (NotificationGuard.isNewOrder(notification)) {
            return {
                title: formatNewOrderTitle(notification),
                subtitle: i18n.t(`notification.type.${notification.type}`),
                body: data.orderCustomerName,
            }
        }

        if (NotificationGuard.isPostponedOrder(notification)) {
            return {
                // @ts-ignore: impossible to typecheck multiple i18next instances
                title: i18n.t(`notification.title.${notification.type}`, {
                    orderShortCode: notification.orderShortCode,
                }),
                subtitle: i18n.t(`notification.type.${notification.type}`),
                // @ts-ignore:
                body: i18n.t(`notification.body.${notification.type}`, {
                    orderShortCode: notification.orderShortCode,
                }),
            }
        }
    }

    throw new Error(`Unknown notification type: ${data.type}`)
}
